module.exports = __webpack_public_path__ + "media/bootstrap-icons/inbox-fill-e3bbf48f.svg";